"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundedContextOfComponent = exports.BOUNDED_CONTEXTS = void 0;
var BOUNDED_CONTEXTS = ['destination/modules/', 'control/modules/', 'shared/modules/']; // is the target set of bounded contexts

exports.BOUNDED_CONTEXTS = BOUNDED_CONTEXTS;

var getBoundedContextOfComponent = function getBoundedContextOfComponent(componentName) {
  var foundContext = BOUNDED_CONTEXTS.find(function (boundedContext) {
    return componentName.startsWith(boundedContext);
  });
  return foundContext;
};

exports.getBoundedContextOfComponent = getBoundedContextOfComponent;